// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__wwAFL","svgIcon":"Home_svgIcon__x3+NT"};